import { render, staticRenderFns } from "./ChequesTab.vue?vue&type=template&id=201a2330&"
import script from "./ChequesTab.vue?vue&type=script&lang=js&"
export * from "./ChequesTab.vue?vue&type=script&lang=js&"
import style0 from "./ChequesTab.vue?vue&type=style&index=0&id=201a2330&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports